// src/modules/shell-cliente/index.js — V2-N Shell Mobile Cliente.

import { sb } from '../../api/supabaseClient.js';
import { maybeStartOnboarding } from '../../lib/onboarding.js';
import '../../lib/avatar.js';
import { uiIco } from '../../lib/uiIcons.js';
import { tenant } from '../../context/tenantContext.js';
import { signOut } from '../../context/authContext.js';
import { esc, initials } from '../../lib/dom.js';
import { calcPctObra } from '../../lib/status.js';
import { fmtDate, relTime } from '../../lib/format.js';
import { loadingHTML, emptyState } from '../../lib/loading.js';
import { showToast } from '../../lib/toast.js';
import { mountMobileTopbar, unmountMobileTopbar } from '../../lib/mobileTopbar.js';
import { contarNotificacoesNaoLidas, abrirNotificacoesMobile, incrementarBadgeMobile } from '../../lib/mobileNotificacoes.js';
import { iniciarNotificacoesRealtime } from '../../lib/notificacoesRealtime.js';
import { signFotosUrls } from '../../lib/signedUrl.js';
import { loadRdosCliente, pendCount, rdoClienteSectionHTML, wireRdoList } from './rdoCliente.js';
import { openMeusChamadosMobile } from '../helpdesk/meusChamadosMobile.js';
import './styles.css';

const STATE = {
  cliente: null,
  obras: [],
  page: 'painel',
  galleryIdx: 0,
  galleryTimer: null,
  feedTimer: null,
  badges: { notif: 0 },
  lastScroll: 0,
};

// Cache da query de arquivos (evita re-query a cada troca de aba). TTL 60s.
let _arqCache = { data: null, ts: 0, key: '' };

export async function render() {
  document.body.classList.add('modo-cliente');
  const root = document.getElementById('app-root');
  if (!root) return;
  // Portal do Cliente é feature PRO (matriz 04/06). Trial mantém (vitrine com demo user).
  if (['canteiro', 'obra'].includes(tenant.config?.plano)) {
    root.innerHTML = `
      <div style="min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:32px;text-align:center">
        <div style="font-size:40px">🔒</div>
        <div style="font-size:17px;font-weight:700">Portal do Cliente indisponível</div>
        <div style="font-size:13px;color:var(--text2,var(--sc-idle));max-width:300px;line-height:1.6">
          O acompanhamento online da obra faz parte do plano <b>Construtora</b>.
          Fale com a construtora responsável pela sua obra.
        </div>
        <button id="cli-sair" style="margin-top:10px;padding:10px 24px;border-radius:10px;border:none;background:var(--primary);color:var(--sc-info-fg);font-weight:600;cursor:pointer">Sair</button>
      </div>`;
    document.getElementById('cli-sair')?.addEventListener('click', () => signOut());
    return;
  }
  root.innerHTML = `<div class="cli-shell" id="cli-shell">${loadingHTML('Carregando…')}</div>`;
  // ilha anexada ao body (fora do #app-root) — evita stacking que esconde a barra
  document.getElementById('cliente-bottom-nav')?.remove();
  const _nav = document.createElement('nav');
  _nav.id = 'cliente-bottom-nav';
  _nav.setAttribute('aria-label', 'Navegação');
  document.body.appendChild(_nav);
  await _loadBase();
  await _loadBadges();
  const _sh = document.getElementById('cli-shell');
  _sh?.addEventListener('scroll', () => _onScroll(_sh), { passive: true });
  iniciarNotificacoesRealtime(() => { STATE.badges.notif = (STATE.badges.notif || 0) + 1; _navSyncCli(); });
  _renderBnav();
  await _renderPage('painel');
  maybeStartOnboarding();
}

async function _loadBase() {
  if (!tenant.user?.id) return;
  const { data: cls } = await sb.from('clientes')
    .select('id,nome_razao_social')
    .eq('user_id', tenant.user.id)
    .order('created_at', { ascending: false })
    .limit(1);
  STATE.cliente = (cls || [])[0] || null;
  if (!STATE.cliente) return;

  const { data: obras } = await sb.from('obras')
    .select('id,nome,status,data_previsao_fim,etapas_obra(nome_etapa,progresso,ordem,peso,valor_etapa)')
    .eq('cliente_id', STATE.cliente.id)
    .order('created_at', { ascending: false });
  STATE.obras = obras || [];
}

function _hero(main, sub) {
  const url = tenant.profile?.avatar_url;
  const inner = url ? `<img src="${esc(url)}" alt="">` : esc(initials(tenant.profile?.nome || STATE.cliente?.nome_razao_social || '') || '·');
  const dark = !document.documentElement.classList.contains('light');
  return `<div class="clm-hero" id="clm-hero">
    <div class="clm-avw" id="clm-avw" role="button" aria-label="Trocar foto"><div class="clm-av">${inner}</div><div class="clm-cam">${uiIco('camera', 11)}</div>
      <input type="file" id="clm-avin" accept="image/*" style="display:none" onchange="uploadAvatar(this)"></div>
    <div class="clm-hi">${esc(main)}${sub ? `<small>${esc(sub)}</small>` : ''}</div>
    <button class="clm-tgl" id="clm-tgl" aria-label="Alternar tema">${uiIco(dark ? 'moon' : 'sun', 18)}</button>
  </div>`;
}
function _wireHero() {
  const _h = document.getElementById('clm-hero');
  const _avw = document.getElementById('clm-avw');
  const _tgl = document.getElementById('clm-tgl');
  const _pop = (el, c) => { if (!el) return; el.classList.remove(c); void el.offsetWidth; el.classList.add(c); };
  if (_h) _h.addEventListener('pointerdown', () => _pop(_h, 'react'));
  if (_avw) _avw.addEventListener('pointerdown', () => _pop(_avw, 'pop'));
  if (_tgl) _tgl.addEventListener('pointerdown', () => _pop(_tgl, 'pop'));
  if (_tgl) _tgl.onclick = () => { const lt = document.documentElement.classList.toggle('light'); try { localStorage.setItem('angular-theme', lt ? 'light' : 'dark'); } catch (_) {} _tgl.innerHTML = uiIco(lt ? 'sun' : 'moon', 18); };
  if (_avw) _avw.onclick = (e) => { if (e.target.tagName === 'INPUT') return; document.getElementById('clm-avin')?.click(); };
}
async function _loadBadges() {
  STATE.badges = { notif: 0 };
  try { STATE.badges.notif = await contarNotificacoesNaoLidas(); } catch (_) {}
}
function _onScroll(shell) {
  const nav = document.getElementById('cliente-bottom-nav'); if (!nav) return;
  const t = shell.scrollTop;
  if (t > STATE.lastScroll + 6 && t > 28) nav.classList.add('mini');
  else if (t < STATE.lastScroll - 6) nav.classList.remove('mini');
  STATE.lastScroll = t;
}

async function _renderPage(page) {
  STATE.page = page;
  try { window.scrollTo(0, 0); } catch (_) {}
  if (STATE.galleryTimer) { clearInterval(STATE.galleryTimer); STATE.galleryTimer = null; }
  if (STATE.feedTimer) { clearInterval(STATE.feedTimer); STATE.feedTimer = null; }
  const shell = document.getElementById('cli-shell');
  if (!shell) return;
  shell.innerHTML = loadingHTML('Carregando…');
  try {
    if (page === 'painel') await _renderPainel();
    else if (page === 'obras') _renderObras();
    else if (page === 'portfolio') await _renderPortfolio();
    else if (page === 'arquivos') await _renderArquivos();
    else if (page === 'perfil') _renderPerfil();
    _wireHero();
    _renderBnav();
  } catch (err) {
    console.error('[shell-cliente]', err);
    shell.innerHTML = `<div style="padding:30px;text-align:center;color:var(--sc-bad)">
      <div style="font-size:14px;font-weight:600">Erro ao carregar</div>
      <div style="font-size:12px;font-family:monospace;margin-top:8px">${esc(err.message)}</div>
    </div>`;
  }
}

async function _renderPainel() {
  const shell = document.getElementById('cli-shell');
  if (!shell) return;
  if (!STATE.cliente) {
    shell.innerHTML = emptyState('Perfil de cliente não encontrado. Contate o administrador.', '!');
    return;
  }

  const nome = (STATE.cliente.nome_razao_social || '').split(' ')[0];
  const profileNome = tenant.profile?.nome || nome;
  const avatarInits = initials(profileNome);
  const dataStr = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' });

  const obraIds = STATE.obras.map((o) => o.id);
  let fotos = [];
  if (obraIds.length) {
    const { data: posts } = await sb.from('obra_posts')
      .select('id,obra_id,post_fotos(url),obras(nome)')
      .in('obra_id', obraIds)
      .order('created_at', { ascending: false })
      .limit(15);
    (posts || []).forEach((p) => {
      (p.post_fotos || []).forEach((f) => {
        if (f.url) fotos.push({ url: f.url, obra_id: p.obra_id, obra_nome: p.obras?.nome || '' });
      });
    });
  }
  fotos = fotos.slice(0, 5);
  await signFotosUrls(fotos);

  const ativas = STATE.obras.filter((o) => o.status === 'em_andamento').length;
  const concluidas = STATE.obras.filter((o) => o.status === 'concluida').length;

  shell.innerHTML = _hero('Olá, ' + (nome || ''), dataStr) + `
    ${fotos.length ? `
      <div class="cli-mob-gallery" id="cli-gallery" data-obra-id="${fotos[0].obra_id}" data-action="abrir-obra">
        <img id="cli-gallery-img" src="${esc(fotos[0].url)}" alt="">
        <div class="cli-mob-gallery-meta">
          <div class="cli-mob-gallery-obra" id="cli-gallery-obra">${esc(fotos[0].obra_nome || 'Obra')}</div>
          <div class="cli-mob-gallery-progress">Foto recente · toque para abrir</div>
        </div>
        ${fotos.length > 1 ? `
        <button class="cli-mob-gallery-nav prev" data-gallery="prev"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg></button>
        <button class="cli-mob-gallery-nav next" data-gallery="next"><svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg></button>
        <div class="cli-mob-gallery-dots" id="cli-gallery-dots">${fotos.map((_, k) => `<span class="${k === 0 ? 'active' : ''}"></span>`).join('')}</div>
        ` : ''}
      </div>
    ` : `
      <div class="cli-mob-gallery-empty">
        <div style="font-weight:600">Sem fotos ainda</div>
        <div style="font-size:11px">A equipe vai postar atualizações em breve</div>
      </div>
    `}

    <div class="cli-mob-kpi-grid">
      <div class="cli-mob-kpi"><div class="v accent">${ativas}</div><div class="l">Em Obra</div></div>
      <div class="cli-mob-kpi"><div class="v green">${concluidas}</div><div class="l">Concluídas</div></div>
      <div class="cli-mob-kpi"><div class="v">${STATE.obras.length}</div><div class="l">Total</div></div>
    </div>

    ${STATE.obras.length ? `
      <div class="cli-mob-section"><h3>Minhas Obras</h3></div>
      ${STATE.obras.slice(0, 3).map((o) => {
        const pct = calcPctObra(o.etapas_obra || []);
        const done = pct >= 100;
        return `<div class="cli-mob-obra-card" data-goto="obras">
          <div class="cli-mob-obra-row">
            <span class="cli-mob-obra-nome">${esc(o.nome)}</span>
            <span class="cli-mob-obra-pct${done ? ' done' : ''}">${pct}%</span>
          </div>
          <div class="cli-mob-obra-bar"><div class="${done ? 'done' : ''}" style="width:${pct}%"></div></div>
        </div>`;
      }).join('')}
    ` : ''}

    <div class="cli-mob-section" style="margin-top:18px"><h3>Atualizações Recentes</h3></div>
    <div id="cli-feed" style="margin-bottom:16px">${loadingHTML('Carregando feed…')}</div>
  `;

  STATE.galleryFotos = fotos;
  STATE.galleryIdx = 0;
  if (fotos.length > 1) {
    STATE.galleryTimer = setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      _galleryGo(STATE.galleryIdx + 1);
    }, 5000);
  }

  _bindPainelListeners();
  await _carregarFeed();
}

function _galleryGo(idx) {
  const fotos = STATE.galleryFotos || [];
  if (!fotos.length) return;
  const i = ((idx % fotos.length) + fotos.length) % fotos.length;
  STATE.galleryIdx = i;
  const img = document.getElementById('cli-gallery-img');
  const obraEl = document.getElementById('cli-gallery-obra');
  const gal = document.getElementById('cli-gallery');
  document.querySelectorAll('#cli-gallery-dots span').forEach((d, k) => d.classList.toggle('active', k === i));
  if (img) img.src = fotos[i].url;
  if (obraEl) obraEl.textContent = fotos[i].obra_nome || 'Obra';
  if (gal) gal.dataset.obraId = fotos[i].obra_id || '';
}

function _bindPainelListeners() {
  document.querySelectorAll('[data-goto]').forEach((el) => {
    el.addEventListener('click', () => _renderPage(el.dataset.goto));
  });
  document.querySelectorAll('[data-action="perfil"]').forEach((el) => {
    el.addEventListener('click', () => _renderPage('perfil'));
  });
  document.querySelectorAll('[data-action="theme"]').forEach((el) => {
    el.addEventListener('click', (e) => { e.stopPropagation(); const lt = document.documentElement.classList.toggle('light'); try { localStorage.setItem('angular-theme', lt ? 'light' : 'dark'); } catch (_) {} });
  });
  document.querySelectorAll('[data-gallery]').forEach((el) => {
    el.addEventListener('click', (e) => { e.stopPropagation(); _galleryGo(STATE.galleryIdx + (el.dataset.gallery === 'next' ? 1 : -1)); });
  });
  document.querySelectorAll('[data-action="abrir-obra"]').forEach((el) => {
    el.addEventListener('click', () => _renderPage('obras'));
  });
}

// ── Feed real (lazy import + auto-refresh 30s) ─────────────────────
async function _carregarFeed() {
  const cont = document.getElementById('cli-feed');
  if (!cont) return;
  if (!cont.dataset.goBound) { cont.dataset.goBound = '1'; cont.addEventListener('click', (e) => { const g = e.target.closest('[data-go]'); if (g) { const p = g.dataset.go; STATE.page = p; STATE.badges.notif = 0; _navSyncCli(); _renderPage(p); } }); }
  try {
    const mod = await import('./feed.js');
    await _renderFeed(mod);
    mod.bindFeedActions(cont);

    if (STATE.feedTimer) { clearInterval(STATE.feedTimer); STATE.feedTimer = null; }
    STATE.feedTimer = setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      if (STATE.page !== 'painel') { clearInterval(STATE.feedTimer); STATE.feedTimer = null; return; }
      _renderFeed(mod).catch(() => {});
    }, 30000);
  } catch (err) {
    console.error('[shell-cliente] feed', err);
    cont.innerHTML = '<div class="feed-empty">Não foi possível carregar o feed.</div>';
  }
}

async function _renderFeed(mod) {
  const cont = document.getElementById('cli-feed');
  if (!cont) return;
  const obraIds = STATE.obras.map((o) => o.id);

  const [postsR, notifsR, tarefasR] = await Promise.allSettled([
    obraIds.length
      ? sb.from('obra_posts')
        .select('*,users_profile(nome,avatar_url),post_fotos(*),post_likes(usuario_id),post_comentarios(*,users_profile(nome,avatar_url)),obras(id,nome)')
        .in('obra_id', obraIds)
        .order('created_at', { ascending: false })
        .limit(30)
      : Promise.resolve({ data: [] }),
    sb.from('notificacoes')
      .select('*')
      .eq('usuario_id', tenant.user?.id || '')
      .in('tipo', ['etapa_concluida', 'rdo_pendente'])
      .order('created_at', { ascending: false })
      .limit(20),
    obraIds.length
      ? sb.from('tarefas')
        .select('id,titulo,data_conclusao,obra_id,etapas_obra(nome_etapa),obras(nome)')
        .in('obra_id', obraIds)
        .eq('status', 'concluida')
        .order('data_conclusao', { ascending: false })
        .limit(10)
      : Promise.resolve({ data: [] }),
  ]);

  const posts = postsR.status === 'fulfilled' ? (postsR.value.data || []) : [];
  await Promise.all(posts.map((p) => signFotosUrls(p.post_fotos || [])));
  const notifs = notifsR.status === 'fulfilled' ? (notifsR.value.data || []) : [];
  const tarefas = tarefasR.status === 'fulfilled' ? (tarefasR.value.data || []) : [];

  cont.innerHTML = mod.buildFeedHTML(posts, notifs, tarefas);
}

async function _renderObras() {
  const shell = document.getElementById('cli-shell');
  if (!shell) return;
  shell.innerHTML = loadingHTML('Carregando…');
  if (!STATE.cliente) { shell.innerHTML = emptyState('Perfil não encontrado.', '!'); return; }

  const { data: obras } = await sb.from('obras')
    .select('id,nome,status,data_inicio,data_previsao_fim,valor_contrato,endereco,etapas_obra(nome_etapa,progresso,ordem,peso,valor_etapa)')
    .eq('cliente_id', STATE.cliente.id).order('created_at', { ascending: false });
  const lista = obras || [];
  const obraIds = lista.map((o) => o.id);
  const contasPorObra = {};
  if (obraIds.length) {
    const { data: contas } = await sb.from('contas_receber')
      .select('id,obra_id,descricao,valor,valor_recebido,data_vencimento,data_recebimento,status')
      .in('obra_id', obraIds);
    (contas || []).forEach((cr) => { (contasPorObra[cr.obra_id] ||= []).push(cr); });
  }

  const corStatus = { em_andamento: 'var(--sc-info)', concluida: 'var(--sc-ok)', pausada: 'var(--sc-warn)', planejamento: 'var(--sc-info)', cancelada: 'var(--sc-bad)' };
  const fmtBR = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const _emAndamento = lista.filter((o) => o.status === 'em_andamento').length;

  shell.innerHTML = `
    <div style="padding-bottom:8px">
      ${_hero('Minhas Obras', `${lista.length} obra${lista.length !== 1 ? 's' : ''}${_emAndamento ? ' · ' + _emAndamento + ' em andamento' : ''}`)}
      <div style="padding:14px 16px">
      ${lista.length === 0
        ? emptyState('Nenhuma obra encontrada.', uiIco('home', 40))
        : lista.map((o) => {
          const etapas = o.etapas_obra || [];
          const pct = etapas.length ? calcPctObra(etapas) : 0;
          const cor = corStatus[o.status] || 'var(--text3)';
          const statusLabel = { em_andamento: 'Em andamento', concluida: 'Concluída', pausada: 'Pausada', planejamento: 'Planejamento', cancelada: 'Cancelada' }[o.status] || o.status;
          const contas = contasPorObra[o.id] || [];
          const totalLancado = contas.reduce((s, c) => s + Number(c.valor || 0), 0);
          const totalPago = contas.reduce((s, c) => s + Number(c.valor_recebido || 0), 0);
          const valorContrato = Number(o.valor_contrato || 0);
          const baseSaldo = valorContrato > 0 ? valorContrato : totalLancado;
          const saldoPagar = Math.max(0, baseSaldo - totalPago);
          const pctPago = baseSaldo > 0 ? Math.min(100, Math.round((totalPago / baseSaldo) * 100)) : 0;
          const quitado = saldoPagar < 0.01 && baseSaldo > 0;
          const hoje = new Date().toISOString().slice(0, 10);
          const proximas = contas.filter((c) => c.status !== 'pago' && Number(c.valor_recebido || 0) < Number(c.valor || 0))
            .sort((a, b) => (a.data_vencimento || '').localeCompare(b.data_vencimento || '')).slice(0, 3);
          const pagas = contas.filter((c) => Number(c.valor_recebido || 0) > 0)
            .sort((a, b) => (b.data_recebimento || b.data_vencimento || '').localeCompare(a.data_recebimento || a.data_vencimento || '')).slice(0, 5);

          const financeiroHTML = (contas.length === 0 && !valorContrato) ? '' : `
            <div style="margin-top:14px;padding-top:14px;border-top:1px dashed var(--border)">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">
                <div style="font-size:13px;font-weight:700;display:flex;align-items:center;gap:6px">${uiIco('money', 14)} Resumo Financeiro</div>
                ${quitado ? `<span style="font-size:10px;font-weight:700;color:var(--green);background:color-mix(in oklab, var(--sc-ok) 12%, transparent);padding:3px 8px;border-radius:20px">${uiIco('check', 11)} QUITADO</span>` : ''}
              </div>
              <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:10px">
                <div style="background:var(--muted);border-radius:8px;padding:8px;text-align:center"><div style="font-size:9px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Contrato</div><div style="font-size:12px;font-weight:700;margin-top:2px">${fmtBR(baseSaldo)}</div></div>
                <div style="background:color-mix(in oklab, var(--sc-ok) 8%, transparent);border-radius:8px;padding:8px;text-align:center"><div style="font-size:9px;color:var(--green);text-transform:uppercase;letter-spacing:.4px;font-weight:600">Pago</div><div style="font-size:12px;font-weight:700;margin-top:2px;color:var(--green)">${fmtBR(totalPago)}</div></div>
                <div style="background:${quitado ? 'color-mix(in oklab, var(--sc-ok) 8%, transparent)' : 'color-mix(in oklab, var(--sc-warn) 10%, transparent)'};border-radius:8px;padding:8px;text-align:center"><div style="font-size:9px;color:${quitado ? 'var(--green)' : 'var(--amber)'};text-transform:uppercase;letter-spacing:.4px;font-weight:600">Saldo</div><div style="font-size:12px;font-weight:700;margin-top:2px;color:${quitado ? 'var(--green)' : 'var(--amber)'}">${fmtBR(saldoPagar)}</div></div>
              </div>
              <div style="height:6px;background:var(--muted);border-radius:3px;overflow:hidden;margin-bottom:12px"><div style="height:100%;width:${pctPago}%;background:linear-gradient(90deg,var(--green),var(--sc-info));border-radius:3px;transition:width .3s"></div></div>
              <div style="text-align:center;font-size:11px;color:var(--text3);margin-bottom:10px">${pctPago}% pago de ${fmtBR(baseSaldo)}</div>
              ${proximas.length ? `<div style="margin-bottom:10px"><div style="font-size:11px;font-weight:700;color:var(--text2);margin-bottom:6px;text-transform:uppercase;letter-spacing:.5px">Próximas parcelas</div>${proximas.map((p) => { const venc = p.data_vencimento; const atrasada = venc && venc < hoje; const valorRestante = Number(p.valor || 0) - Number(p.valor_recebido || 0); return `<div style="display:flex;justify-content:space-between;align-items:center;background:var(--muted);border-radius:8px;padding:8px 10px;margin-bottom:4px;border-left:3px solid ${atrasada ? 'var(--red)' : 'var(--amber)'}"><div><div style="font-size:12px;font-weight:600">${fmtBR(valorRestante)}</div><div style="font-size:10px;color:var(--text3)">${esc(p.descricao || 'Parcela')}</div></div><div style="text-align:right"><div style="font-size:11px;color:${atrasada ? 'var(--red)' : 'var(--text2)'};font-weight:600">${venc ? fmtDate(venc) : '—'}</div>${atrasada ? `<div style="font-size:9px;color:var(--red);font-weight:700">ATRASADA</div>` : ''}</div></div>`; }).join('')}</div>` : ''}
              ${pagas.length ? `<details style="margin-top:8px"><summary style="font-size:11px;font-weight:700;color:var(--text2);text-transform:uppercase;letter-spacing:.5px;cursor:pointer;padding:6px 0">Histórico de pagamentos (${pagas.length})</summary><div style="margin-top:6px">${pagas.map((p) => `<div style="display:flex;justify-content:space-between;align-items:center;background:color-mix(in oklab, var(--sc-ok) 6%, transparent);border-radius:8px;padding:7px 10px;margin-bottom:4px;border-left:3px solid var(--green)"><div><div style="font-size:12px;font-weight:600;color:var(--green);display:flex;align-items:center;gap:4px">${uiIco('check', 11)} ${fmtBR(p.valor_recebido)}</div><div style="font-size:10px;color:var(--text3)">${esc(p.descricao || 'Parcela')}</div></div><div style="font-size:11px;color:var(--text2)">${p.data_recebimento ? fmtDate(p.data_recebimento) : (p.data_vencimento ? fmtDate(p.data_vencimento) : '—')}</div></div>`).join('')}</div></details>` : ''}
            </div>`;

          return `
          <div style="background:var(--card);border:0.5px solid var(--glass-border);border-radius:16px;overflow:hidden;margin-bottom:12px">
            <div style="padding:16px">
              <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px">
                <div style="font-size:15px;font-weight:700;flex:1">${esc(o.nome)}</div>
                <span style="font-size:11px;font-weight:600;color:${cor};background:${cor}15;padding:3px 10px;border-radius:20px;margin-left:8px;flex-shrink:0">${statusLabel}</span>
              </div>
              ${o.endereco ? `<div style="font-size:12px;color:var(--text3);margin-bottom:10px;display:flex;align-items:center;gap:5px">${uiIco('pin', 12)} ${esc(o.endereco)}</div>` : ''}
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
                <span style="font-size:12px;color:var(--text3)">Progresso</span>
                <span style="font-size:13px;font-weight:700;color:${cor}">${pct}%</span>
              </div>
              <div style="height:8px;background:var(--muted);border-radius:4px;overflow:hidden;margin-bottom:12px"><div style="height:100%;width:${pct}%;background:${pct >= 100 ? 'var(--green)' : 'linear-gradient(90deg,var(--sc-info),var(--sc-info))'};border-radius:4px;transition:width .3s"></div></div>
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px">
                ${[{ label: 'Início', val: fmtDate(o.data_inicio) }, { label: 'Previsão', val: fmtDate(o.data_previsao_fim) }, { label: 'Contrato', val: o.valor_contrato ? 'R$ ' + Number(o.valor_contrato).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '—' }, { label: 'Etapas', val: `${etapas.length} etapa${etapas.length !== 1 ? 's' : ''}` }].map((info) => `<div style="background:var(--muted);border-radius:10px;padding:10px"><div style="font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">${info.label}</div><div style="font-size:13px;font-weight:600;margin-top:2px">${info.val || '—'}</div></div>`).join('')}
              </div>
              ${financeiroHTML}
            </div>
          </div>`;
        }).join('')}
      </div>
    </div>`;
}

async function _renderArquivos() {
  const shell = document.getElementById('cli-shell');
  if (!shell) return;
  const obraIds = STATE.obras.map((o) => o.id);
  const cacheKey = obraIds.slice().sort().join(',');
  let arquivos;
  if (_arqCache.data && _arqCache.key === cacheKey && (Date.now() - _arqCache.ts) < 60000) {
    arquivos = _arqCache.data;
  } else {
    arquivos = [];
    if (obraIds.length) {
      const { data } = await sb.from('arquivos_obra')
        .select('id,nome:nome_arquivo,tipo,url,created_at,obras(nome)')
        .in('obra_id', obraIds)
        .or('visivel_cliente.is.null,visivel_cliente.eq.true')
        .order('created_at', { ascending: false })
        .limit(50);
      arquivos = data || [];
    }
    _arqCache = { data: arquivos, ts: Date.now(), key: cacheKey };
  }
  await signFotosUrls(arquivos);
  const nObras = STATE.obras.length;
  const rdos = await loadRdosCliente(STATE.obras);
  const _pend = pendCount(rdos);
  const _subHero = (_pend ? `${_pend} RDO para assinar · ` : '') + `${arquivos.length} documento${arquivos.length !== 1 ? 's' : ''} · ${nObras} obra${nObras !== 1 ? 's' : ''}`;
  shell.innerHTML = `
    ${_hero('Arquivos & RDO', _subHero)}
    ${rdoClienteSectionHTML(rdos)}
    ${arquivos.length === 0
      ? `<div class="empty-state" style="padding:60px 16px">
           <div class="empty-state-icon" style="display:flex;justify-content:center;align-items:center">
             <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="var(--sc-info)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
           </div>
           <div class="empty-state-text">Nenhum arquivo disponível ainda.</div>
         </div>`
      : arquivos.map((a) => `
          <a class="cli-mob-file" href="${a.url || '#'}" target="_blank" rel="noopener" style="text-decoration:none;color:inherit">
            <div class="cli-mob-file-ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            </div>
            <div class="cli-mob-file-txt">
              <div class="cli-mob-file-nome">${esc(a.nome || 'arquivo')}</div>
              <div class="cli-mob-file-meta">${esc(a.obras?.nome || '—')} · ${relTime(a.created_at)}</div>
            </div>
          </a>
        `).join('')}
  `;
  wireRdoList(shell, () => { _arqCache = { data: null, ts: 0, key: '' }; _renderArquivos(); });
}

function _renderPerfil() {
  const shell = document.getElementById('cli-shell');
  if (!shell) return;
  const nome = tenant.profile?.nome || tenant.user?.email || '—';
  const email = tenant.user?.email || '—';
  const inits = (nome || '?').split(' ').slice(0, 2).map((n) => n[0] || '').join('').toUpperCase();
  const avHTML = tenant.profile?.avatar_url ? `<img src="${tenant.profile.avatar_url}" alt="">` : esc(inits);
  shell.innerHTML = `
    <div style="padding-bottom:30px">
      ${_hero(nome, email)}
      <input type="file" id="avatar-file-input-cli-perfil" accept="image/jpeg,image/png,image/webp" style="display:none" onchange="uploadAvatar(this)">
      <div class="cli-mob-perfil-list">
        <button class="cli-mob-perfil-row" data-action="chamados">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg></div>
          <div class="lbl">Meus Chamados</div>
          <span class="arr"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></span>
        </button>
        <button class="cli-mob-perfil-row" onclick="document.getElementById('avatar-file-input-cli-perfil').click()">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg></div>
          <div class="lbl">Alterar foto</div>
          <span class="arr"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></span>
        </button>
        <button class="cli-mob-perfil-row danger" style="margin-top:14px" data-action="logout">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></div>
          <div class="lbl">Sair da conta</div>
        </button>
      </div>
    </div>`;
  shell.querySelector('[data-action="logout"]')?.addEventListener('click', () => signOut());
  shell.querySelector('[data-action="chamados"]')?.addEventListener('click', () => openMeusChamadosMobile());
}

async function _renderPortfolio() {
  const shell = document.getElementById('cli-shell');
  if (!shell) return;
  const { data: obras } = await sb.from('portfolio_obras')
    .select('*,portfolio_fotos(url,capa,ordem),portfolio_likes(usuario_id),portfolio_comentarios(id)')
    .eq('publicado', true)
    .order('destaque', { ascending: false })
    .order('ordem')
    .order('ano_conclusao', { ascending: false });
  const lista = obras || [];
  for (const o of lista) {
    if (Array.isArray(o.portfolio_fotos)) await signFotosUrls(o.portfolio_fotos);
  }
  if (!lista.length) {
    shell.innerHTML = _hero('Portfólio', 'Obras realizadas por ' + (tenant.config?.nome || '')) + '<div style="padding:18px">' + emptyState('Nenhuma obra no portfólio ainda.', '🏗') + '</div>';
    return;
  }
  const tipoLabel = { residencial: 'Residencial', comercial: 'Comercial', industrial: 'Industrial', infraestrutura: 'Infraestrutura', reforma: 'Reforma', outro: 'Outro' };
  shell.innerHTML = _hero('Portfólio', 'Obras realizadas por ' + (tenant.config?.nome || ''))
    + '<div style="padding:18px">'
    + lista.map((o) => {
        const capa = (o.portfolio_fotos || []).find((f) => f.capa) || (o.portfolio_fotos || [])[0];
        const tipo = tipoLabel[o.tipo] || '';
        return '<div style="background:var(--card);border:0.5px solid var(--glass-border);border-radius:14px;overflow:hidden;margin-bottom:14px">'
          + (capa ? `<img src="${esc(capa.url)}" style="width:100%;height:180px;object-fit:cover;display:block">` : '')
          + '<div style="padding:14px">'
          + `<div style="font-size:15px;font-weight:700;margin-bottom:4px">${esc(o.nome)}</div>`
          + `<div style="font-size:12px;color:var(--text3)">${esc(tipo)}${o.ano_conclusao ? ' · ' + o.ano_conclusao : ''}${o.local ? ' · ' + esc(o.local) : ''}</div>`
          + (o.descricao ? `<div style="font-size:13px;color:var(--text2);margin-top:8px">${esc(o.descricao)}</div>` : '')
          + '</div></div>';
      }).join('')
    + '</div>';
}

function _renderBnav() {
  const nav = document.getElementById('cliente-bottom-nav');
  if (!nav) return;
  const items = [
    { p: 'painel',    svg: '<rect x="3" y="3" width="8" height="8" rx="1.5"/><rect x="13" y="3" width="8" height="8" rx="1.5"/><rect x="3" y="13" width="8" height="8" rx="1.5"/><rect x="13" y="13" width="8" height="8" rx="1.5"/>' },
    { p: 'obras',     svg: '<path d="M3 21V7l9-4 9 4v14M9 21V12h6v9"/>' },
    { p: 'portfolio', svg: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>' },
    { p: 'arquivos',  svg: '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>' },
    { p: 'perfil',    svg: '<circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>' },
  ];
  if (nav.dataset.built !== '1') {
    nav.innerHTML = '<div class="cli-hl"></div>' + items.map((it) =>
      `<button class="cnav-btn" data-page="${it.p}" aria-label="${it.p}"><svg viewBox="0 0 24 24">${it.svg}</svg><span class="nav-ind"></span></button>`).join('');
    nav.dataset.built = '1';
    nav.querySelectorAll('[data-page]').forEach((el) => {
      el.addEventListener('click', () => { STATE.page = el.dataset.page; if (el.dataset.page === 'painel') STATE.badges.notif = 0; _navSyncCli(); _renderPage(el.dataset.page); });
      el.addEventListener('pointerdown', () => { el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); nav.classList.remove('tapped'); void nav.offsetWidth; nav.classList.add('tapped'); });
    });
  }
  _navSyncCli();
}
function _navSyncCli() {
  const nav = document.getElementById('cliente-bottom-nav');
  if (!nav) return;
  const b = STATE.badges || {};
  nav.querySelectorAll('[data-page]').forEach((el) => {
    el.classList.toggle('on', STATE.page === el.dataset.page);
    const ind = el.querySelector('.nav-ind');
    if (!ind) return;
    if (el.dataset.page === 'painel' && b.notif) ind.innerHTML = `<span class="cli-bdg">${b.notif > 99 ? '99+' : b.notif}</span>`;
    else ind.innerHTML = '';
  });
  const on = nav.querySelector('.cnav-btn.on'); const hl = nav.querySelector('.cli-hl');
  if (on && hl) { hl.style.width = on.offsetWidth + 'px'; hl.style.transform = `translateX(${on.offsetLeft}px)`; }
}

export function teardown() {
  document.body.classList.remove('modo-cliente');
  unmountMobileTopbar();
  document.getElementById('cliente-bottom-nav')?.remove();
  if (STATE.galleryTimer) { clearInterval(STATE.galleryTimer); STATE.galleryTimer = null; }
  if (STATE.feedTimer) { clearInterval(STATE.feedTimer); STATE.feedTimer = null; }
}
